import React from 'react';
import { Menu, Search, Play, Archive, Info, ShoppingCart, User, LogOut, Box } from 'lucide-react';
import { cn } from '../../utils/icons';


interface SideNavProps {
  isOpen: boolean;
  onClose: () => void;
}

const navItems = [
  { icon: Menu, label: 'Menu' },
  { icon: Search, label: 'Danh sách địa điểm' },
  { icon: Play, label: 'Tour tự động' },
  { icon: Archive, label: 'Kho tư liệu' },
  { icon: Info, label: 'Khám phá thông tin' },
  { icon: Box, label: 'Thư viện 3D' },
  { icon: ShoppingCart, label: 'Giỏ hàng', badge: 2 },
  { icon: User, label: 'Tài khoản của tôi', avatar: '/placeholder.svg' },
  { icon: LogOut, label: 'Thoát ra' }
];

const SideNav: React.FC<SideNavProps> = ({ isOpen, onClose }) => {
  
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop overlay */}
      <div 
        className="fixed inset-0 bg-black/50 z-30"
        onClick={onClose}
      />

      {/* Main SideNav */}      <nav className={cn(
        "fixed z-40",
        "w-[290px] h-[70vh]",
        "top-[25px] left-[25px]",
        "glass_background rounded-[16px] backdrop-blur-[100px]",
        "shadow-[0px_4px_16px_0px_rgba(0,0,0,0.2),inset_-1px_1px_3px_0px_rgba(255,255,255,0.8),inset_0px_4px_10px_3px_rgba(255,255,255,0.2)]",
        "rounded-[42px] p-[10px]",
        "transition-transform duration-300",
        isOpen ? "translate-x-0" : "-translate-x-full"
      )}>
        <div className="flex flex-col gap-2 h-full overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
          {/* Menu Button */}
          <button 
            onClick={onClose}
            className="w-full flex items-center p-3 rounded-full bg-[var(--button-primary-button-primary-bg-default),_rgba(255,255,255,1)] shadow-[0px_4px_16px_0px_rgba(0,0,0,0.2),inset_-1px_1px_3px_0px_rgba(255,255,255,0.8),inset_0px_4px_10px_3px_rgba(255,255,255,0.2)] hover:bg-gray-50 transition-all"
          >
            <Menu className="w-10 h-10 text-gray-600 stroke-[3]" />
            <span className="text-gray-600 font-bold text-lg ml-3">Menu</span>
          </button>

          {/* Navigation Groups */}
          <div className="space-y-2">
            {navItems.slice(1).map((item, index) => (
              <React.Fragment key={index}>
                <button 
                  className="w-full flex items-center p-3 rounded-full bg-[var(--button-primary-button-primary-bg-default),_rgba(255,255,255,1)] shadow-[0px_4px_16px_0px_rgba(0,0,0,0.2),inset_-1px_1px_3px_0px_rgba(255,255,255,0.8),inset_0px_4px_10px_3px_rgba(255,255,255,0.2)] hover:bg-gray-50 transition-all"
                >
                  <div className="relative flex items-center">
                    {item.avatar ? (
                      <div className="w-10 h-10 rounded-full bg-gray-400 border border-gray-100 overflow-hidden">
                        <img src={item.avatar} alt="" className="w-full h-full object-cover" />
                      </div>
                    ) : (
                      <item.icon className="w-10 h-10 text-gray-600 stroke-[3]" />
                    )}
                    {item.badge && (
                      <div className="absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center bg-red-500 text-white text-sm font-extrabold rounded-full shadow-[0px_4px_4px_0px_rgba(0,0,0,0.1)]">
                        {item.badge}
                      </div>
                    )}
                    <span className="text-gray-600 font-bold text-lg ml-3">{item.label}</span>
                  </div>
                </button>
                {(index + 1) % 2 === 0 && index < navItems.length - 4 && (
                  <div className="w-[222px] h-[6px] mx-auto my-2 rounded-full glass_background rounded-[16px] shadow-[0px_4px_16px_0px_rgba(0,0,0,0.2),inset_-1px_1px_3px_0px_rgba(255,255,255,0.8),inset_0px_4px_10px_3px_rgba(255,255,255,0.2)]" />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </nav>
    </>
  );
};

export default SideNav;